import React from 'react';
import about from '../images/about_org.jpg';
import digitalcommunication from '../images/digitalcommunication.png';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function DigitalCommunication() {
  useDocTitle("Digital Communication");

  return (
    <div>
      {/* Hero Section */}
     <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Digital Communication Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

        <div className="relative z-20 h-full flex items-center justify-center text-center text-white">
  <h2 className={`${commonStyles.pageTitle} text-white`}>
    Digital Communication
  </h2>
</div>
      </div>
<CommonContainer>
      {/* Section Title */}
      {/* <div className="mt-16">
        <p className="font-bold text-blue-500 mb-6 text-center
                      text-lg md:text-xl lg:text-2xl">
          Digital Communication
        </p>
      </div> */}

      {/* Content Section */}
     <div className="flex flex-col lg:flex-row items-center
                my-8 gap-8">
        {/* Text */}
        <div className="w-full lg:w-1/2">

  <h1 className={`${commonStyles.heading} mb-6`}>
    Digital Communication
  </h1>
          <p className={`${commonStyles.paragraph} mb-4`}>
            Effective digital communication is essential for modern businesses.
            It helps brands deliver the right message to the right audience at
            the right time across multiple digital platforms.
          </p>

         <p className={`${commonStyles.paragraph} mb-4`}>
            At Quadprosoft Technologies, we design communication strategies that
            strengthen brand identity, improve engagement, and build lasting
            customer relationships through meaningful digital interactions.
          </p>
        </div>

        {/* Image */}
        <div className="w-full lg:w-1/2 my-5">
          <img
            src={digitalcommunication}
            alt="Digital Communication"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>
      </div>

      {/* Services List */}
      <div>
        <div className="mt-10">
          <ul className="space-y-8 ml-10">
            {[
              {
                title: 'Brand Communication Strategy',
                desc:
                  'Define a clear brand voice and messaging framework to ensure consistency across all digital communication channels.',
              },
              {
                title: 'Content Creation & Messaging',
                desc:
                  'Create SEO-friendly website content, blogs, and social media messaging that connects with your audience and drives engagement.',
              },
              {
                title: 'Social Media Management',
                desc:
                  'Manage and grow your social media presence by building authentic relationships and meaningful audience engagement.',
              },
              {
                title: 'Email & Newsletter Campaigns',
                desc:
                  'Design targeted email campaigns and newsletters that inform, nurture, and retain your customers.',
              },
              {
                title: 'Visual & Multimedia Content',
                desc:
                  'Develop engaging videos, infographics, and presentations that enhance storytelling and brand recall.',
              },
              {
                title: 'Reputation Management',
                desc:
                  'Monitor online conversations, reviews, and feedback to protect and strengthen your brand’s digital reputation.',
              },
            ].map((item) => (
              <li key={item.title}>
                <div className="flex items-start text-[23px] font-bold text-blue-900">
                 <span className="text-green-500 text-[30] mr-3 mt-1">✔</span>
                  {item.title}
                </div>
               <p className="mt-2 text-[18px] leading-8 text-gray-600 text-left">
                  {item.desc}
                </p>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <div className="my-10">
         <p className={`${commonStyles.paragraph} mb-4`}>
            To find out more about our digital communication services, please{' '}
            <a href="/contact" className="text-blue-500 hover:underline">
              contact us
            </a>.
          </p>
        </div>
      </div>
      </CommonContainer>
    </div>
  );
}

export default DigitalCommunication;
